import { TOrgHeirachy } from '@monorepo/types';
import * as _ from 'lodash';
import { TEnhancedOrgHeirachyModel, TOrgHeirachyModel } from './org-heirarchy.types';
import { UTIL_ORG_HEIRARCHY } from './org-heirarchy.util';

export const TASKS_ORG_HEIRARCHY = {
  collapseExpandNode: (enhancedOrgTree: TEnhancedOrgHeirachyModel): TEnhancedOrgHeirachyModel => {
    const toggleNodeId = enhancedOrgTree.toggleNode?.enhancedNodeInfo.id;
    const rec = (orgTreeModel: TOrgHeirachyModel['values']): TOrgHeirachyModel['values'] => {
      const result = orgTreeModel.map((node) => {
        return {
          ...node,
          children: node.children
            ? {
                ...node.children,
                nodes: rec(node.children.nodes),
              }
            : undefined,
          enhancedNodeInfo: {
            ...node.enhancedNodeInfo,
            isMinimized:
              toggleNodeId === node.enhancedNodeInfo.id
                ? !node.enhancedNodeInfo.isMinimized
                : node.enhancedNodeInfo.isMinimized,
          },
        };
      });
      return result;
    };

    return {
      ...enhancedOrgTree,
      orgTreeModel: {
        ...enhancedOrgTree.orgTreeModel,
        values: rec(enhancedOrgTree.orgTreeModel.values),
      },
    };
  },

  createPayload: (enhancedOrgTree: TEnhancedOrgHeirachyModel): TEnhancedOrgHeirachyModel => {
    const rec = (orgTreeModel: TOrgHeirachyModel['values']): TOrgHeirachy['values'] => {
      const result = _.compact(
        orgTreeModel.map((node) => {
          const updatedNode = _.omit(node, 'enhancedNodeInfo');
          if (node.enhancedNodeInfo.isSelected) {
            return {
              ...updatedNode,
              children: node.children
                ? {
                    ...node.children,
                    nodes: rec(node.children.nodes),
                  }
                : undefined,
            };
          } else {
            return undefined;
          }
        }),
      );
      return result;
    };

    const payloadValues = rec(enhancedOrgTree.orgTreeModel.values);

    return {
      ...enhancedOrgTree,
      payload: payloadValues[0]?.children
        ? {
            ...enhancedOrgTree.orgTreeModel,
            values: payloadValues,
          }
        : undefined,
    };
  },

  setParentSelection: (enhancedOrgTree: TEnhancedOrgHeirachyModel): TEnhancedOrgHeirachyModel => {
    const rec = (orgTreeModel: TOrgHeirachyModel['values']): TOrgHeirachyModel['values'] => {
      const result = orgTreeModel.map((node) => {
        if (node.children) {
          const isSelected = node.children
            ? UTIL_ORG_HEIRARCHY.isNodeSelected(node.children.nodes)
            : node.enhancedNodeInfo.isSelected;
          return {
            ...node,
            enhancedNodeInfo: {
              ...node.enhancedNodeInfo,
              isSelected,
            },
            children: {
              ...node.children,
              nodes: rec(node.children.nodes),
            },
          };
        } else {
          return node;
        }
      });
      return result;
    };

    return {
      ...enhancedOrgTree,
      orgTreeModel: {
        ...enhancedOrgTree.orgTreeModel,
        values: rec(enhancedOrgTree.orgTreeModel.values),
      },
    };
  },

  selectAllChildNodes(enhancedOrgTree: TEnhancedOrgHeirachyModel): TEnhancedOrgHeirachyModel {
    const rec = (
      orgTreeModel: TOrgHeirachyModel['values'],
      parentNodeSelection?: boolean,
    ): TOrgHeirachyModel['values'] => {
      const result = orgTreeModel.map((node) => {
        let isSelected = node.enhancedNodeInfo.isSelected;
        let childNodesSelection:boolean | undefined  = undefined;
        if (enhancedOrgTree.selectedNode?.data.enhancedNodeInfo.id === node.enhancedNodeInfo.id) {
          isSelected = enhancedOrgTree.selectedNode?.data.enhancedNodeInfo.isSelected;
          childNodesSelection = isSelected;
        } else if (typeof parentNodeSelection !== 'undefined') {
          isSelected = parentNodeSelection;
          childNodesSelection = parentNodeSelection;
        }
        if (node.children) {
          return {
            ...node,
            enhancedNodeInfo: {
              ...node.enhancedNodeInfo,
              isSelected,
            },
            children: {
              ...node.children,
              nodes: rec(node.children.nodes, childNodesSelection),
            },
          };
        } else {
          return {
            ...node,
            enhancedNodeInfo: {
              ...node.enhancedNodeInfo,
              isSelected,
            },
          };
        }
      });
      return result;
    };

    return {
      ...enhancedOrgTree,
      orgTreeModel: {
        ...enhancedOrgTree.orgTreeModel,
        values: rec(enhancedOrgTree.orgTreeModel.values),
      },
    };
  },
};
